import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { FetchUserMetadataResponse } from 'client/modules/AnchorAPI/v3/users/fetchUserMetadata';
import { useQuery } from 'react-query';
import { AnchorAPI } from '../../modules/AnchorAPI';

function useFetchUserMetadata() {
  const {
    state: { userId },
  } = useCurrentUserCtx();

  const { data, status } = useQuery<FetchUserMetadataResponse>(
    ['userMetadata'],
    () =>
      AnchorAPI.fetchUserMetadata({
        currentUserId: userId as number,
      }),
    {
      enabled: !!userId,
    }
  );
  console.log(data);
  return {
    data,
    status,
  };
}

export { useFetchUserMetadata };
